import { LoadingDotsIcon } from "mds/icons";

/**
 * Bare `/home` redirects to `/home/<role>` (see Observers).
 * Admin: `admin.tsx`. Other personas: `[role].tsx`.
 */
export default function Page() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <LoadingDotsIcon />
    </div>
  );
}
